/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import Session from '../Session';

/**
 * Returns the details of the currently logged in user.
 */
export function getUserDetails() {
  return Session?.user;
}

/**
 * Returns whether or not a user has been authorized.
 */
export function isAuthorized() {
  return Session?.user.isAuthorized === '1';
}

/**
 * Returns whether or not a user belongs to a given role.
 * @param {string} requiredRole target role being checked
 * @returns {boolean} true if user has role, false if user does not have role
 * @example
 * User has the role 'Case Manager'
 *
 * userHasRole('Case Manager')
 * -> true
 */
export function userHasRole(requiredRole) {
  const userRoles = Session?.user?.userRoles;
  return userRoles?.some((userRoles) => userRoles.internalUserType === requiredRole);
}

/**
 * Returns whether or not a user belongs to any one of a list of roles
 * @param {...string} requiredRoles variable number of roles to check
 * @returns {boolean} true if user has any of listed roles, false if user does not have any of those roles
 * @example
 * User has the role 'Case Manager'
 *
 * userHasAnyRoles('Case Manager', 'Reviewer')
 * -> true
 */
export function userHasAnyRoles(...requiredRoles) {
  return _.some(Session?.user?.userMgmtRoles, (userRole) => {
    return _.includes(requiredRoles, userRole.role);
  });
}

/**
 * Returns whether or not a user belongs to any one of a list of epc region groups
 * @param {...string} regionGroups variable number of regionsGroups to check
 * @returns {boolean} true if user  belongs to any of listed groups, false if user does not have any of those groups
 */
export function userIsInRegionGroup(...regionGroups) {
  return _.includes(regionGroups, Session?.user?.epcRegionGroup);
}
